import { NgModule } from '@angular/core';
import { SwitchCasesDirective } from './switch-cases.directive';
@NgModule({
    declarations: [SwitchCasesDirective],
    exports: [SwitchCasesDirective],
})
export class AppDirectiveModule {}
